const groupFeaturedCompanyFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const companyGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`company-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `company-${index}-name`)) {
      break;
    }

    companyGroups.push({ index, fields: groupFields });
  }

  return { introFields, companyGroups };
};

export default groupFeaturedCompanyFields;
